import type { MetricInfo, SetPlanInfo, StepPlanInfo } from '@az3fr/core';
import { memo } from 'react';

import type { SectionPlanInfo } from '@/features/workout-creator/ui/v2/sets-editor/types/sets-editor.types';
import { MetricCellV2 } from '@/features/workout-creator/ui/v2/sets-editor/components/MetricCell-v2';
import { SetNumberCellV2 } from '@/features/workout-creator/ui/v2/sets-editor/components/SetNumberCell-v2';
import { useSetActions } from '@/features/workout-creator/ui/v2/sets-editor/hooks';

function SetRowV2(props: {
	orderIndex: number;
	setPlan: SetPlanInfo;
	metrics: MetricInfo[];
	stepPlan: StepPlanInfo;
	sectionPlan: SectionPlanInfo;
}) {
	const { orderIndex, setPlan, metrics, stepPlan, sectionPlan } = props;
	const { deleteSet } = useSetActions();

	const handleDeleteSet = () => {
		deleteSet(setPlan.id);
	};

	return (
		<>
			<SetNumberCellV2
				orderIndex={orderIndex}
				repetitionMode={stepPlan.repetitionMode}
				sectionType={sectionPlan.sectionType}
				sectionRounds={sectionPlan.rounds}
				templateSets={stepPlan.templateSets ?? undefined}
				stepPlanId={stepPlan.id}
				onDeleteSet={handleDeleteSet}
			/>

			{metrics.map((metric) => (
				<MetricCellV2
					key={`${setPlan.id}-${metric.canonicalName}`}
					setPlanId={setPlan.id}
					metricCanonicalName={metric.canonicalName}
					metric={metric}
				/>
			))}
		</>
	);
}

const MemoizedSetRowV2 = memo(SetRowV2);

export { MemoizedSetRowV2 as SetRowV2 };
